<form fxFlexOffset="20px" fxLayout="column" [formGroup]="form">
  <h2>Цены на товар: {{ product?.name }}</h2>

  <button type="button" mat-raised-button (click)="onSave()" [disabled]="saveInProgress">{{ saveInProgress ? 'Идет сохранение...' : 'Сохранить'}}</button>
</form>
